import { RootState } from 'src/store/reduxTypes';
import { CoachmarkTourKey } from 'src/store/ui/types';

export const selectCoachmarkActive =
  (key: CoachmarkTourKey) =>
  (state: RootState): boolean =>
    state.ui.coachmark[key]?.active ?? false;

export const selectCoachmarkCompleted =
  (key: CoachmarkTourKey) =>
  (state: RootState): boolean =>
    state.ui.coachmark[key]?.completed ?? false;

export const selectIsStudioClientPreview = (state: RootState): boolean =>
  state.ui.isStudioClientPreview;
